import React from "react"
import moment from "moment"

// UI
import {Row, Col} from "@uprise/grid"
import {Medium} from "@uprise/text"

const Header = ({custom, title, timestamp}) => {
	const format = custom ? "DD/MM/YYYY" : "MMMM Do YYYY, h:mm:ss a"
	const date = moment.unix(timestamp).format(format)

	return custom ? (
		<Row>
			<Col className='col-6 col-lg-6 col-md-6 col-sm-12'>
				<div>{title}</div>
			</Col>
			<Col className='col-6 col-lg-6 col-md-6 col-sm-12'>
				<Medium className='m-r-5 text-right'>{"Summary " + date}</Medium>
			</Col>
		</Row>
	) : (
		<>
			{title} - {date}
		</>
	)
}

export default Header
